__turbopack_context__.v({
  "className": "gochi_hand_8dff3376-module__lq6jaa__className",
  "variable": "gochi_hand_8dff3376-module__lq6jaa__variable",
});
